module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h1', {
    staticClass: "red"
  }, [_vm._v("Product Page : " + _vm._s(_vm.slug))]), _vm._v(" "), _c('div', [_vm._v(_vm._s(_vm.data.vendor))]), _vm._v(" "), _c('div', [_vm._v(_vm._s(_vm.data.type))]), _vm._v(" "), _c('div', [_vm._v(_vm._s(_vm.data.title))])])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-ea60d784", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-ea60d784","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/ProductDetailView.vue
// module id = 61
// module chunks = 0